
export default {
  data: function () {
    return {
      handleVideo: {
        youTubeId: 'S5o5H697lss',
        youTubeLink: 'https://www.youtube.com/embed/S5o5H697lss?autoplay=1&modestbranding=1&start=0&enablejsapi=1&rel=0&showinfo=0&controls=0&disableekb=0&fs=0&mute=1',
      },
      isShow: false,
    }
  },

  mounted: function() {
    this.showPopup()
  },

  computed: {
    videoId: function () {
      return this.$store.state?.appState?.vars?.['ВСЕ_О_НАС_ID_ВИДЕО']
    },
    imageUrl: function () {
      return `https://img.youtube.com/vi/${ this.videoId }/0.jpg`
    },
    videoUrl: function () {
      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&modestbranding=1&start=0&enablejsapi=1&rel=0&showinfo=0&controls=0&disableekb=0&fs=0&mute=1`
    },
  },

  methods: {
    openVideo: function (videoUrl) {
      this.isShow = false;
      this.$store.commit('pop-up-video/setOpen', {
        link: videoUrl
      });

      const reachGoalOpen = this.$store?.state?.appState?.vars?.['ВСЕ_О_НАС_ЦЕЛЬ_ОТКРЫТИЯ'];
      if (!!reachGoalOpen) {
        this.$yaglaaction(reachGoalOpen);
        this.$yandexMetrika.reachGoal(reachGoalOpen);
      }
    },
    showPopup: function () {
      // setTimeout(() => {
      //   this.isShow = Boolean(this.videoId)
      // }, 5000)
    },
    closePopUpAboutCompany: function () {
      this.isShow = false;
    }
  }
}
